import { render } from "./Main.vue?vue&type=template&id=5d974a6c&scoped=true"
import script from "./Main.vue?vue&type=script&lang=ts"
export * from "./Main.vue?vue&type=script&lang=ts"

import "./Main.vue?vue&type=style&index=0&id=5d974a6c&scoped=true&lang=css"
import "./Main.vue?vue&type=style&index=1&id=5d974a6c&lang=css"
script.render = render
script.__scopeId = "data-v-5d974a6c"

export default script